import state from "./moduleTipologyState.js";
import mutations from "./moduleTipologyMutations.js";
import actions from "./moduleTipologyActions.js";
import getters from "./moduleTipologyGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
